// Side panel that opens on row click. Shows the full event JSON + a deep
// link to the Step Functions console (when execution_arn is present).

import { formatMessage, formatSource } from "../format";
import type { PipelineEvent } from "../types";

export function DrillDown({ event, onClose }: { event: PipelineEvent; onClose: () => void }) {
  const consoleLink = event.execution_arn ? sfnConsoleLink(event.execution_arn) : null;

  return (
    <aside className="drilldown">
      <div className="drilldown-header">
        <div>
          <div className={"drilldown-sev level-" + event.severity.toLowerCase()}>
            {event.severity}
          </div>
          <h2>{formatMessage(event.message, event.tenant_id)}</h2>
          <div className="drilldown-meta">
            {event.pipeline_label} · {formatSource(event.source_system)} · {event.ts_utc}
          </div>
        </div>
        <button className="drilldown-close" onClick={onClose} aria-label="close">
          ✕
        </button>
      </div>

      {consoleLink && (
        <a href={consoleLink} target="_blank" rel="noreferrer" className="drilldown-link">
          Open in Step Functions console ↗
        </a>
      )}

      <h3>Full event</h3>
      <pre className="drilldown-json">{JSON.stringify(event, null, 2)}</pre>
    </aside>
  );
}

function sfnConsoleLink(executionArn: string): string {
  // arn:aws:states:{region}:{acct}:execution:{sm}:{id}
  const parts = executionArn.split(":");
  const region = parts[3] ?? "us-east-1";
  return `https://${region}.console.aws.amazon.com/states/home?region=${region}#/executions/details/${encodeURIComponent(
    executionArn,
  )}`;
}
